import axios from 'axios'
import store from '../store'

const HOSTNAME = process.env.VUE_APP_BASE_API

const getToken = function () {
    let token = window.localStorage.getItem('token')
    if (token == null || token == undefined) {
        return null
    } else {
        return `Bearer ${token}`
    }
}

export async function request(method, url, data, auth = false, contentType = 'application/json', responseType = null) {
    let headers = {}

    if (auth) {
        headers = { Authorization: getToken(), 'Content-Type': contentType }
    } else {
        headers = { 'Content-Type': contentType }
    }
    url = HOSTNAME + url

    try {
        let response
        if (responseType != null) {
            response = await axios({ method, url, data, headers, responseType: responseType })
        } else {
            response = await axios({ method, url, data, headers })
        }
        return response
    } catch (error) {
        if (error?.response?.status === 401 && !error?.response?.data.statusCode) {
            // AuthService.logout()
            store.dispatch('auth/logout')
            window.location.href = '/'
            return
        }
        return Promise.reject(error)
    }
}

export const queryParams = (req) => {
    let query = '?'
    Object.keys(req).forEach((key) => {
        if (req[key]) {
            if (query != '?') {
                query += '&'
            }
            query += key + '=' + req[key]
        }
    })
    if (query === '?') return ''
    return query
}

export function extractResponseData(response) {
    return {
        id: response.data.data?.id,       // id from response data
        status: response.data.status,     // status from response
        message: response.data.message,   // message from response
        data: response.data.data          // main data object
    };
}